import React, { useState } from "react";
import { suggestCompanies } from "../api";

const SearchBar = ({ onSelect, defaultValue = "" }) => {
  const [query, setQuery] = useState(defaultValue);
  const [suggestions, setSuggestions] = useState([]);
  // const [loading, setLoading] = useState(false); // Unused for now
  const debounceTimeout = React.useRef(null);

  // Debounce suggestion fetch
  const handleInputChange = (e) => {
    const val = e.target.value;
    setQuery(val);

    if (debounceTimeout.current) clearTimeout(debounceTimeout.current);

    if (!val.trim()) {
      setSuggestions([]);
      return;
    }

    debounceTimeout.current = setTimeout(async () => {
      // setLoading(true);
      const results = await suggestCompanies(val.trim());
      setSuggestions(results || []);
      // setLoading(false);
    }, 300);
  };

  const handleSelect = (ticker) => {
    setQuery(ticker);
    setSuggestions([]);
    onSelect(ticker);
  };

  return (
    <div className="panel" style={{ position: "relative", zIndex: 50 }}>
      <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
        <input
          className="input"
          placeholder="Search company name, ticker, or domain"
          value={query}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              handleSelect(query); // Enter = Select current input
            }
          }}
        />
        <button className="button" onClick={() => handleSelect(query)} disabled={!query}>
          Go
        </button>
      </div>
      {suggestions.length > 0 && (
        <div
          style={{
            marginTop: 10,
            borderRadius: 10,
            border: "1px solid #1f2a44",
            background: "#0f182b",
            position: "absolute",
            width: "100%",
            top: "100%",
            left: 0,
            boxShadow: "0 4px 20px rgba(0,0,0,0.5)"
          }}
        >
          {suggestions.map((s) => (
            <div
              key={s.ticker}
              style={{ padding: "10px 12px", cursor: "pointer", borderBottom: "1px solid #1f2a44" }}
              onClick={() => handleSelect(s.ticker)}
            >
              <div style={{ fontWeight: 600 }}>{s.name}</div>
              <div className="tag">
                {s.ticker} {s.domain ? `· ${s.domain}` : ""}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBar;
